import { ContentfulImage } from "@2u-landing-pages/components";
import { ContentfulImageConfig } from "@2u-landing-pages/types";
import { useContentfulInspectorMode } from "@contentful/live-preview/react";
import { FC, useEffect, useRef } from "react";
import { MarqueeProps } from "./Marquee.types";
// @ts-ignore
import styles from "./Marquee.module.scss";

export const Marquee: FC<MarqueeProps> = ({ content = [], scroll_direction, scroll_speed }) => {
  const marqueeContainerRef = useRef<HTMLDivElement>(null);
  const marqueeContentRef = useRef<HTMLDivElement>(null);
  const inspector = useContentfulInspectorMode();

  const marqueeContainerStyle = {
    "--scroll-direction": scroll_direction === "right" ? "1" : "-1",
    "--scroll-speed": scroll_speed,
  } as React.CSSProperties;

  useEffect(() => {
    if (!marqueeContainerRef.current || !marqueeContentRef.current) return;

    const marqueeContainer = marqueeContainerRef.current;
    const content = marqueeContentRef.current;
    const contentList = content.querySelectorAll("ul");
    if (contentList.length === 0) return;

    const checkOverflow = () => {
      if (content.childElementCount === 1) {
        const clonedList = content.querySelector("ul")?.cloneNode(true) as HTMLElement;
        if (clonedList) {
          clonedList.classList.add("cloned");
          content.appendChild(clonedList);
        }
      }

      const containerWidth = marqueeContainer.offsetWidth;
      const contentListWidth = contentList[0].offsetWidth;
      const isOverflowing = contentListWidth > containerWidth;

      if (isOverflowing) {
        content.classList.add("enable-animation");
      } else {
        content.classList.remove("enable-animation");
      }
    };

    const resizeObserver = new ResizeObserver(checkOverflow);
    resizeObserver.observe(marqueeContainer);
    checkOverflow();

    // Cleanup function
    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <div ref={marqueeContainerRef} className={styles.marquee} role="marquee" style={marqueeContainerStyle}>
      <div ref={marqueeContentRef} className={styles.marqueeContent}>
        <ul>
          {content?.map((item) => (
            <li key={item?.sys?.id} className={styles.marqueeItem}>
              <ContentfulImage
                image={item?.fields?.image}
                className={styles.logo}
                config={item?.fields?.image_config as unknown as ContentfulImageConfig}
                loading="eager"
                width={200}
                {...inspector({
                  entryId: item?.sys?.id || "",
                  fieldId: "marquee_item",
                })}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
